import React from "react";
import { createPortal } from "react-dom";
import { Box, Typography } from "@mui/material";
import { useAppStore } from "../../stores/appStore";
import {
  offlineBannerStyles,
  onlineBannerStyles,
  mainContentStyles,
  iconStyles,
  messageTextStyles,
} from "./styles";

const InternetStatusBanner: React.FC = () => {
  const { isOnline, showReloadBanner } = useAppStore();

  const banner = showReloadBanner ? (
    <Box sx={onlineBannerStyles}>
      <Box sx={mainContentStyles}>
        <Typography sx={messageTextStyles}>
          Connection restored. Reloading page...
        </Typography>
      </Box>
    </Box>
  ) : !isOnline ? (
    <Box sx={offlineBannerStyles}>
      <Box sx={mainContentStyles}>
        <Box
          component="svg"
          sx={iconStyles}
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fillRule="evenodd"
            d="M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11.707 4.707a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
            clipRule="evenodd"
          />
        </Box>
        <Typography sx={messageTextStyles}>
          No internet connection. Messages will be sent when connection is
          restored.
        </Typography>
      </Box>
    </Box>
  ) : null;

  if (!banner) return null;

  return createPortal(banner, document.body);
};

export default InternetStatusBanner;
